(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nb-about-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var MAX_SCALE = 0.18;
    var MAX_BLUR = 2.5;
    var SIGMA = 180;

    var sections = document.querySelectorAll('.nb-about-gallery');
    for (var s = 0; s < sections.length; s++) {
      (function (root) {
        if (root.getAttribute('data-nb-ag-dock') !== null) return;
        root.setAttribute('data-nb-ag-dock', '');

        var slider = root.querySelector('.nb-about-gallery__slider');
        var track = root.querySelector('.nb-about-gallery__track');
        if (!slider || !track) return;
        var photos = Array.prototype.slice.call(track.querySelectorAll('.nb-about-gallery__photo'));
        if (!photos.length) return;

        var raf = null;
        var mx = null;

        function tick() {
          raf = null;
          if (mx === null) return;
          for (var i = 0; i < photos.length; i++) {
            var el = photos[i];
            var r = el.getBoundingClientRect();
            var cx = r.left + r.width / 2;
            var dx = mx - cx;
            var f = Math.exp(-(dx * dx) / (2 * SIGMA * SIGMA));
            el.style.setProperty('--nb-ag-s', (1 + MAX_SCALE * f).toFixed(3));
            el.style.setProperty('--nb-ag-b', (MAX_BLUR * (1 - f)).toFixed(2) + 'px');
            el.style.zIndex = f > 0.6 ? '2' : '';
          }
          raf = window.requestAnimationFrame(tick);
        }

        function onEnter(e) {
          mx = e.clientX;
          if (raf === null) raf = window.requestAnimationFrame(tick);
        }

        function onMove(e) {
          mx = e.clientX;
        }

        function reset() {
          mx = null;
          if (raf !== null) {
            window.cancelAnimationFrame(raf);
            raf = null;
          }
          for (var i = 0; i < photos.length; i++) {
            photos[i].style.setProperty('--nb-ag-s', '1');
            photos[i].style.setProperty('--nb-ag-b', '0px');
            photos[i].style.zIndex = '';
          }
        }

        slider.addEventListener('pointerenter', onEnter, { passive: true });
        slider.addEventListener('pointermove', onMove, { passive: true });
        slider.addEventListener('pointerleave', reset);
      })(sections[s]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-about-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var canHover = window.matchMedia('(hover: hover)').matches;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var BASE_BLUR = 0;
    var MAX_BLUR = 4;
    var MAX_OFFSET = 10;
    var SIGMA_FACTOR = 0.32;

    var sections = document.querySelectorAll('.nb-about-hero');
    for (var s = 0; s < sections.length; s++) {
      (function (root) {
        if (root.getAttribute('data-nb-ah-reveal') === null) {
          root.setAttribute('data-nb-ah-reveal', '');
          var revStickers = Array.prototype.slice.call(root.querySelectorAll('.nb-about-hero__sticker'));
          if (revStickers.length) {
            if (!reduceMotion && 'IntersectionObserver' in window) {
              var io = new IntersectionObserver(function (entries) {
                for (var e = 0; e < entries.length; e++) {
                  if (entries[e].isIntersecting) {
                    entries[e].target.classList.add('is-visible');
                    io.unobserve(entries[e].target);
                  }
                }
              }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
              for (var r = 0; r < revStickers.length; r++) io.observe(revStickers[r]);
            } else {
              for (var r2 = 0; r2 < revStickers.length; r2++) revStickers[r2].classList.add('is-visible');
            }
          }
        }

        if (!canHover || reduceMotion) return;
        if (root.getAttribute('data-nb-ah-stickers') !== null) return;
        root.setAttribute('data-nb-ah-stickers', '');

        var container = root.querySelector('.nb-about-hero__decor');
        if (!container) return;
        var stickers = Array.prototype.slice.call(container.querySelectorAll('.nb-about-hero__sticker'));
        if (!stickers.length) return;

        var raf = null;
        var mx = 0;
        var my = 0;

        function apply() {
          raf = null;
          var cRect = container.getBoundingClientRect();
          var sigma = Math.max(cRect.width, cRect.height) * SIGMA_FACTOR || 300;
          var R_IN = 60;
          var R_OUT = 200;
          var SPREAD = 180;

          var data = [];
          var dMin = Infinity;

          for (var i = 0; i < stickers.length; i++) {
            var el = stickers[i];
            var left = cRect.left + el.offsetLeft;
            var top = cRect.top + el.offsetTop;
            var right = left + el.offsetWidth;
            var bottom = top + el.offsetHeight;
            var cx = left + el.offsetWidth / 2;
            var cy = top + el.offsetHeight / 2;

            var ddx = Math.max(left - mx, 0, mx - right);
            var ddy = Math.max(top - my, 0, my - bottom);
            var d = Math.sqrt(ddx * ddx + ddy * ddy);

            var dxc = mx - cx;
            var dyc = my - cy;
            var dc = Math.sqrt(dxc * dxc + dyc * dyc) || 1;
            var f = Math.exp(-(dc * dc) / (2 * sigma * sigma));

            data.push({ el: el, d: d, dxc: dxc, dyc: dyc, dc: dc, f: f });
            if (d < dMin) dMin = d;
          }

          var gate = (R_OUT - dMin) / (R_OUT - R_IN);
          gate = Math.max(0, Math.min(1, gate));

          for (var j = 0; j < data.length; j++) {
            var it = data[j];
            var ox = (it.dxc / it.dc) * MAX_OFFSET * it.f * gate;
            var oy = (it.dyc / it.dc) * MAX_OFFSET * it.f * gate;
            var scale = 1 + 0.04 * it.f * gate;
            var b = (it.d - dMin) / SPREAD;
            b = Math.max(0, Math.min(1, b));
            var blur = MAX_BLUR * b * gate;

            it.el.style.setProperty('--nb-ah-sticker-dx', ox.toFixed(2) + 'px');
            it.el.style.setProperty('--nb-ah-sticker-dy', oy.toFixed(2) + 'px');
            it.el.style.setProperty('--nb-ah-sticker-scale', scale.toFixed(3));
            it.el.style.setProperty('--nb-ah-sticker-blur', blur.toFixed(2) + 'px');
          }
        }

        function onMove(e) {
          if (e.pointerType && e.pointerType !== 'mouse') return;
          mx = e.clientX;
          my = e.clientY;
          if (raf === null) raf = window.requestAnimationFrame(apply);
        }

        function reset() {
          for (var i = 0; i < stickers.length; i++) {
            var el = stickers[i];
            el.style.setProperty('--nb-ah-sticker-dx', '0px');
            el.style.setProperty('--nb-ah-sticker-dy', '0px');
            el.style.setProperty('--nb-ah-sticker-scale', '1');
            el.style.setProperty('--nb-ah-sticker-blur', BASE_BLUR + 'px');
          }
        }

        root.addEventListener('pointermove', onMove, { passive: true });
        root.addEventListener('pointerleave', reset);
      })(sections[s]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-about-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var canHover = window.matchMedia('(hover: hover)').matches;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var BASE_BLUR = 0;
    var MAX_BLUR = 4;
    var MAX_OFFSET = 10;
    var SIGMA_FACTOR = 0.32;

    var sections = document.querySelectorAll('.nb-about-story');
    for (var s = 0; s < sections.length; s++) {
      (function (root) {
        if (root.getAttribute('data-nb-as-reveal') === null) {
          root.setAttribute('data-nb-as-reveal', '');
          var revStickers = Array.prototype.slice.call(root.querySelectorAll('.nb-about-story__sticker'));
          if (revStickers.length) {
            if (!reduceMotion && 'IntersectionObserver' in window) {
              var io = new IntersectionObserver(function (entries) {
                for (var e = 0; e < entries.length; e++) {
                  if (entries[e].isIntersecting) {
                    entries[e].target.classList.add('is-visible');
                    io.unobserve(entries[e].target);
                  }
                }
              }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
              for (var r = 0; r < revStickers.length; r++) io.observe(revStickers[r]);
            } else {
              for (var r2 = 0; r2 < revStickers.length; r2++) revStickers[r2].classList.add('is-visible');
            }
          }
        }

        if (!canHover || reduceMotion) return;
        if (root.getAttribute('data-nb-as-stickers') !== null) return;
        root.setAttribute('data-nb-as-stickers', '');

        var container = root.querySelector('.nb-about-story__decor');
        if (!container) return;
        var stickers = Array.prototype.slice.call(container.querySelectorAll('.nb-about-story__sticker'));
        if (!stickers.length) return;

        var raf = null;
        var mx = 0;
        var my = 0;

        function apply() {
          raf = null;
          var cRect = container.getBoundingClientRect();
          var sigma = Math.max(cRect.width, cRect.height) * SIGMA_FACTOR || 300;
          var R_IN = 60;
          var R_OUT = 200;
          var SPREAD = 180;

          var data = [];
          var dMin = Infinity;

          for (var i = 0; i < stickers.length; i++) {
            var el = stickers[i];
            var left = cRect.left + el.offsetLeft;
            var top = cRect.top + el.offsetTop;
            var right = left + el.offsetWidth;
            var bottom = top + el.offsetHeight;
            var cx = left + el.offsetWidth / 2;
            var cy = top + el.offsetHeight / 2;

            var ddx = Math.max(left - mx, 0, mx - right);
            var ddy = Math.max(top - my, 0, my - bottom);
            var d = Math.sqrt(ddx * ddx + ddy * ddy);

            var dxc = mx - cx;
            var dyc = my - cy;
            var dc = Math.sqrt(dxc * dxc + dyc * dyc) || 1;
            var f = Math.exp(-(dc * dc) / (2 * sigma * sigma));

            data.push({ el: el, d: d, dxc: dxc, dyc: dyc, dc: dc, f: f });
            if (d < dMin) dMin = d;
          }

          var gate = (R_OUT - dMin) / (R_OUT - R_IN);
          gate = Math.max(0, Math.min(1, gate));

          for (var j = 0; j < data.length; j++) {
            var it = data[j];
            var ox = (it.dxc / it.dc) * MAX_OFFSET * it.f * gate;
            var oy = (it.dyc / it.dc) * MAX_OFFSET * it.f * gate;
            var scale = 1 + 0.04 * it.f * gate;
            var b = (it.d - dMin) / SPREAD;
            b = Math.max(0, Math.min(1, b));
            var blur = MAX_BLUR * b * gate;

            it.el.style.setProperty('--nb-as-sticker-dx', ox.toFixed(2) + 'px');
            it.el.style.setProperty('--nb-as-sticker-dy', oy.toFixed(2) + 'px');
            it.el.style.setProperty('--nb-as-sticker-scale', scale.toFixed(3));
            it.el.style.setProperty('--nb-as-sticker-blur', blur.toFixed(2) + 'px');
          }
        }

        function onMove(e) {
          if (e.pointerType && e.pointerType !== 'mouse') return;
          mx = e.clientX;
          my = e.clientY;
          if (raf === null) raf = window.requestAnimationFrame(apply);
        }

        function reset() {
          for (var i = 0; i < stickers.length; i++) {
            var el = stickers[i];
            el.style.setProperty('--nb-as-sticker-dx', '0px');
            el.style.setProperty('--nb-as-sticker-dy', '0px');
            el.style.setProperty('--nb-as-sticker-scale', '1');
            el.style.setProperty('--nb-as-sticker-blur', BASE_BLUR + 'px');
          }
        }

        root.addEventListener('pointermove', onMove, { passive: true });
        root.addEventListener('pointerleave', reset);
      })(sections[s]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var BASE = 40;
    var MAX_BOOST = 320;
    var MOUSE_GAIN = 2;

    function init(root) {
      if (root.hasAttribute('data-nb-marquee')) return;
      root.setAttribute('data-nb-marquee', '');

      var words = root.querySelector('.nb-contact__words');
      var track = root.querySelector('.nb-contact__words-track');
      if (!words || !track) return;
      var first = track.querySelector('.nb-contact__words-img');
      if (!first) return;

      var copyW = 0;
      var offset = 0;
      var boost = 0;
      var last = 0;
      var raf = null;

      function copyWidth() {
        var w = first.getBoundingClientRect().width;
        if (w > 0) copyW = w;
      }

      function centerStatic() {
        copyWidth();
        if (copyW <= 0) return;
        var o = (copyW - words.clientWidth) / 2;
        if (o < 0) o = 0;
        track.style.transform = 'translate3d(' + (-o).toFixed(2) + 'px,0,0)';
      }

      function frame(t) {
        if (!copyW) copyWidth();
        if (!last) last = t;
        var dt = (t - last) / 1000;
        last = t;
        if (dt > 0.1) dt = 0.1;

        boost *= 0.94;
        if (Math.abs(boost) < 0.5) boost = 0;

        offset += (BASE + boost) * dt;
        if (copyW > 0) {
          offset = offset % copyW;
          if (offset < 0) offset += copyW;
        }
        track.style.transform = 'translate3d(' + (-offset).toFixed(2) + 'px,0,0)';
        raf = window.requestAnimationFrame(frame);
      }

      function start() {
        if (!reduce && raf === null) {
          last = 0;
          raf = window.requestAnimationFrame(frame);
        }
      }

      function stop() {
        if (raf !== null) {
          window.cancelAnimationFrame(raf);
          raf = null;
        }
      }

      function onResize() {
        if (reduce) centerStatic();
        else copyWidth();
      }

      window.addEventListener('resize', onResize);

      if (first.complete) copyWidth();
      else first.addEventListener('load', function () { if (reduce) centerStatic(); else copyWidth(); });

      if (reduce) {
        centerStatic();
        return;
      }

      var lastX = null;
      root.addEventListener('mousemove', function (e) {
        if (lastX !== null) {
          boost += (e.clientX - lastX) * MOUSE_GAIN;
          if (boost > MAX_BOOST) boost = MAX_BOOST;
          if (boost < -MAX_BOOST) boost = -MAX_BOOST;
        }
        lastX = e.clientX;
      }, { passive: true });
      root.addEventListener('mouseleave', function () { lastX = null; }, { passive: true });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) start();
            else stop();
          }
        }, { threshold: 0 });
        io.observe(words);
      }
      start();
    }

    function initPaws(root) {
      if (root.hasAttribute('data-nb-paws')) return;
      root.setAttribute('data-nb-paws', '');

      var paws = root.querySelectorAll('.nb-contact__paw');
      if (!paws.length) return;

      function reveal() {
        for (var i = 0; i < paws.length; i++) {
          (function (el, idx) {
            if (reduce) {
              el.classList.add('is-visible');
              return;
            }
            setTimeout(function () { el.classList.add('is-visible'); }, idx * 130);
          })(paws[i], i);
        }
      }

      var revealed = false;
      var raf = null;

      function check() {
        raf = null;
        if (revealed) return;
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight || 1;
        if (r.top < vh && r.bottom > 0) {
          revealed = true;
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          reveal();
        }
      }

      function onScroll() {
        if (raf === null) raf = window.requestAnimationFrame(check);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      check();
    }

    var sections = document.querySelectorAll('.nb-contact');
    for (var i = 0; i < sections.length; i++) {
      init(sections[i]);
      initPaws(sections[i]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-featured-products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var grid = root.querySelector('.nb-fp__grid');
      if (!grid) return;

      var mq = window.matchMedia('(max-width: 749px)');
      var cs = getComputedStyle(grid);
      var maxLift = parseFloat(cs.getPropertyValue('--nb-fp-max-lift')) || 14;

      var cards = Array.prototype.slice.call(grid.querySelectorAll('.nb-fp__media'));

      function neighborDistance() {
        if (cards.length >= 2) {
          var a = cards[0].getBoundingClientRect();
          var b = cards[1].getBoundingClientRect();
          return Math.abs(b.left - a.left);
        }
        return 480;
      }

      function reset() {
        for (var i = 0; i < cards.length; i++) {
          cards[i].style.setProperty('--nb-fp-lift', '0px');
        }
      }

      grid.addEventListener('pointermove', function (e) {
        if (mq.matches) return;
        var sigma = neighborDistance() / 1.177;
        for (var i = 0; i < cards.length; i++) {
          var r = cards[i].getBoundingClientRect();
          var cx = r.left + r.width / 2;
          var cy = r.top + r.height / 2;
          var d = Math.hypot(e.clientX - cx, e.clientY - cy);
          var lift = maxLift * Math.exp(-(d * d) / (2 * sigma * sigma));
          cards[i].style.setProperty('--nb-fp-lift', lift.toFixed(2) + 'px');
        }
      });

      grid.addEventListener('pointerleave', reset);
      grid.addEventListener('pointerenter', function (e) {
        if (e.pointerType) reset();
      });
    }

    var sections = document.querySelectorAll('.nb-fp');
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].getAttribute('data-nb-fp-ready') !== null) continue;
      sections[i].setAttribute('data-nb-fp-ready', '');
      init(sections[i]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-hero-home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var canHover = window.matchMedia('(hover: hover)').matches;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!canHover || reduceMotion) return;

    var BASE_BLUR = 0;
    var MAX_BLUR = 4;
    var MAX_OFFSET = 10;
    var SIGMA_FACTOR = 0.32;

    var sections = document.querySelectorAll('.nb-hero');
    for (var s = 0; s < sections.length; s++) {
      (function (root) {
        if (root.getAttribute('data-nb-stickers-ready') !== null) return;
        root.setAttribute('data-nb-stickers-ready', '');

        var container = root.querySelector('.nb-hero__stickers');
        if (!container) return;
        var stickers = Array.prototype.slice.call(container.querySelectorAll('.nb-hero__sticker'));
        if (!stickers.length) return;

        var raf = null;
        var mx = 0;
        var my = 0;

        function apply() {
          raf = null;
          var cRect = container.getBoundingClientRect();
          var sigma = Math.max(cRect.width, cRect.height) * SIGMA_FACTOR || 300;
          var R_IN = 60;
          var R_OUT = 200;
          var SPREAD = 180;

          var data = [];
          var dMin = Infinity;

          for (var i = 0; i < stickers.length; i++) {
            var el = stickers[i];
            var left = cRect.left + el.offsetLeft;
            var top = cRect.top + el.offsetTop;
            var right = left + el.offsetWidth;
            var bottom = top + el.offsetHeight;
            var cx = left + el.offsetWidth / 2;
            var cy = top + el.offsetHeight / 2;

            var ddx = Math.max(left - mx, 0, mx - right);
            var ddy = Math.max(top - my, 0, my - bottom);
            var d = Math.sqrt(ddx * ddx + ddy * ddy);

            var dxc = mx - cx;
            var dyc = my - cy;
            var dc = Math.sqrt(dxc * dxc + dyc * dyc) || 1;
            var f = Math.exp(-(dc * dc) / (2 * sigma * sigma));

            data.push({ el: el, d: d, dxc: dxc, dyc: dyc, dc: dc, f: f });
            if (d < dMin) dMin = d;
          }

          var gate = (R_OUT - dMin) / (R_OUT - R_IN);
          gate = Math.max(0, Math.min(1, gate));

          for (var j = 0; j < data.length; j++) {
            var it = data[j];
            var ox = (it.dxc / it.dc) * MAX_OFFSET * it.f * gate;
            var oy = (it.dyc / it.dc) * MAX_OFFSET * it.f * gate;
            var scale = 1 + 0.04 * it.f * gate;
            var b = (it.d - dMin) / SPREAD;
            b = Math.max(0, Math.min(1, b));
            var blur = MAX_BLUR * b * gate;

            it.el.style.setProperty('--nb-sticker-dx', ox.toFixed(2) + 'px');
            it.el.style.setProperty('--nb-sticker-dy', oy.toFixed(2) + 'px');
            it.el.style.setProperty('--nb-sticker-scale', scale.toFixed(3));
            it.el.style.setProperty('--nb-sticker-blur', blur.toFixed(2) + 'px');
          }
        }

        function onMove(e) {
          if (e.pointerType && e.pointerType !== 'mouse') return;
          mx = e.clientX;
          my = e.clientY;
          if (raf === null) raf = window.requestAnimationFrame(apply);
        }

        function reset() {
          for (var i = 0; i < stickers.length; i++) {
            var el = stickers[i];
            el.style.setProperty('--nb-sticker-dx', '0px');
            el.style.setProperty('--nb-sticker-dy', '0px');
            el.style.setProperty('--nb-sticker-scale', '1');
            el.style.setProperty('--nb-sticker-blur', BASE_BLUR + 'px');
          }
        }

        root.addEventListener('pointermove', onMove, { passive: true });
        root.addEventListener('pointerleave', reset);
      })(sections[s]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-ingredients"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealItems(items) {
      for (var i = 0; i < items.length; i++) {
        (function (el, idx) {
          if (reduceMotion) {
            el.classList.add('is-visible');
            return;
          }
          setTimeout(function () {
            el.classList.add('is-visible');
          }, idx * 90);
        })(items[i], i);
      }
    }

    function init(root) {
      var slider = root.querySelector('[data-ingredients-slider]');
      var track = root.querySelector('[data-ingredients-track]');
      if (!slider || !track) return;

      var mq = window.matchMedia('(max-width: 749px)');
      var cs = getComputedStyle(slider);
      var maxLift = parseFloat(cs.getPropertyValue('--nb-ing-max-lift')) || 14;

      var items = Array.prototype.slice.call(root.querySelectorAll('.nb-ingredients__item'));
      if (!items.length) return;

      slider.addEventListener('pointermove', function (e) {
        if (mq.matches) return;
        var dist = 200;
        if (items.length >= 2) {
          var a = items[0].getBoundingClientRect();
          var b = items[1].getBoundingClientRect();
          dist = Math.abs(b.left - a.left);
        }
        var sigma = dist / 1.177;
        for (var i = 0; i < items.length; i++) {
          var r = items[i].getBoundingClientRect();
          var cx = r.left + r.width / 2;
          var cy = r.top + r.height / 2;
          var d = Math.hypot(e.clientX - cx, e.clientY - cy);
          var lift = maxLift * Math.exp(-(d * d) / (2 * sigma * sigma));
          items[i].style.setProperty('--nb-ing-lift', lift.toFixed(2) + 'px');
        }
      });

      slider.addEventListener('pointerleave', function () {
        if (mq.matches) return;
        for (var i = 0; i < items.length; i++) {
          items[i].style.setProperty('--nb-ing-lift', '0px');
        }
      });

      var revealed = false;
      var raf = null;

      function check() {
        raf = null;
        if (revealed) return;
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight || 1;
        if (r.top < vh && r.bottom > 0) {
          revealed = true;
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          revealItems(items);
        }
      }

      function onScroll() {
        if (raf === null) raf = window.requestAnimationFrame(check);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      check();
    }

    var sections = document.querySelectorAll('.nb-ingredients');
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].getAttribute('data-nb-ing-ready') !== null) continue;
      sections[i].setAttribute('data-nb-ing-ready', '');
      init(sections[i]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-promo-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      var toast = root.querySelector('.nb-promo-card__toast');
      var toastTimer = null;

      function showToast() {
        if (!toast) return;
        toast.classList.add('nb-promo-card__toast--show');
        clearTimeout(toastTimer);
        toastTimer = setTimeout(function () {
          toast.classList.remove('nb-promo-card__toast--show');
        }, 1800);
      }

      function copyCode(code) {
        if (!code) return;
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(code).then(showToast);
        } else {
          var ta = document.createElement('textarea');
          ta.value = code;
          ta.style.position = 'fixed';
          ta.style.opacity = '0';
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          showToast();
        }
      }

      var pills = root.querySelectorAll('.nb-promo-card__pill');
      for (var i = 0; i < pills.length; i++) {
        pills[i].addEventListener('click', function (e) {
          e.preventDefault();
          copyCode(this.getAttribute('data-copy-code') || '');
        });
      }
    }

    var sections = document.querySelectorAll('.nb-promo-cards');
    for (var s = 0; s < sections.length; s++) {
      if (sections[s].getAttribute('data-nb-promo-ready') !== null) continue;
      sections[s].setAttribute('data-nb-promo-ready', '');
      init(sections[s]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-story"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var sections = document.querySelectorAll('.nb-story');
    for (var s = 0; s < sections.length; s++) {
      (function (root) {
        if (root.getAttribute('data-nb-story-ready') !== null) return;
        root.setAttribute('data-nb-story-ready', '');

        var pin = root.querySelector('.nb-story__pin');
        var body = root.querySelector('.nb-story__body');
        if (!pin || !body) return;

        var raf = null;

        function update() {
          raf = null;
          var vh = window.innerHeight || 1;
          var bodyTop = body.getBoundingClientRect().top;
          var progress = 1 - bodyTop / vh;
          progress = Math.max(0, Math.min(1, progress));
          root.style.setProperty('--nb-story-progress', progress.toFixed(4));
        }

        function onScroll() {
          if (raf === null) raf = window.requestAnimationFrame(update);
        }

        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        update();
      })(sections[s]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-testimonials"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sliders = document.querySelectorAll('[data-testi-slider]');
    for (var s = 0; s < sliders.length; s++) {
      (function (slider) {
        var viewport = slider.querySelector('[data-testi-viewport]');
        var track = slider.querySelector('[data-testi-track]');
        if (!viewport || !track) return;
        var slides = Array.prototype.slice.call(track.children);
        var prev = slider.querySelector('[data-testi-prev]');
        var next = slider.querySelector('[data-testi-next]');
        var dots = Array.prototype.slice.call(slider.querySelectorAll('[data-testi-dot]'));
        var total = slides.length;
        var index = 0;
        var timer = null;
        var autoplay = slider.getAttribute('data-autoplay') === '1';
        var interval = parseInt(slider.getAttribute('data-autoplay-speed'), 10) || 6000;

        if (total <= 1) return;

        var clone = slides[0].cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);

        var realCount = total;
        var items = Array.prototype.slice.call(track.children);
        var itemCount = items.length;

        function render() {
          var i = index % realCount;
          if (i < 0) i += realCount;
          track.style.transform = 'translate3d(' + (-index * 100) + '%,0,0)';
          for (var d = 0; d < dots.length; d++) {
            var active = d === i;
            dots[d].classList.toggle('nb-testi__dot--active', active);
            dots[d].setAttribute('aria-selected', active ? 'true' : 'false');
          }
        }

        function go(i, instant) {
          track.style.transition = instant ? 'none' : 'transform 0.5s ease';
          index = i;
          render();
          if (index >= realCount) {
            setTimeout(function () {
              track.style.transition = 'none';
              index = 0;
              render();
              requestAnimationFrame(function () {
                track.style.transition = 'transform 0.5s ease';
              });
            }, 500);
          }
        }

        function nextSlide() { go(index + 1); }
        function prevSlide() {
          if (index === 0) {
            track.style.transition = 'none';
            index = realCount;
            render();
            requestAnimationFrame(function () {
              go(realCount - 1);
            });
          } else {
            go(index - 1);
          }
        }

        function start() {
          if (autoplay && !timer) {
            timer = setInterval(nextSlide, interval);
          }
        }

        function stop() {
          if (timer) { clearInterval(timer); timer = null; }
        }

        if (prev) prev.addEventListener('click', function () { stop(); prevSlide(); start(); });
        if (next) next.addEventListener('click', function () { stop(); nextSlide(); start(); });

        for (var d = 0; d < dots.length; d++) {
          (function (dot) {
            dot.addEventListener('click', function () {
              stop();
              go(parseInt(dot.getAttribute('data-testi-dot'), 10));
              start();
            });
          })(dots[d]);
        }

        slider.addEventListener('mouseenter', stop);
        slider.addEventListener('mouseleave', start);

        var startX = 0;
        var dragging = false;
        viewport.addEventListener('pointerdown', function (e) {
          dragging = true;
          startX = e.clientX;
        });
        viewport.addEventListener('pointerup', function (e) {
          if (!dragging) return;
          dragging = false;
          var dx = e.clientX - startX;
          if (Math.abs(dx) > 40) {
            if (dx < 0) nextSlide(); else prevSlide();
          }
        });
        viewport.addEventListener('pointercancel', function () { dragging = false; });

        go(0, true);
        start();
      })(sliders[s]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nb-why"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function revealItems(items) {
      for (var i = 0; i < items.length; i++) {
        (function (el, idx) {
          if (reduceMotion) {
            el.classList.add('is-visible');
            return;
          }
          setTimeout(function () {
            el.classList.add('is-visible');
          }, idx * 90);
        })(items[i], i);
      }
    }

    function init(root) {
      var items = Array.prototype.slice.call(root.querySelectorAll('.nb-why__sello'));
      if (!items.length) return;

      var revealed = false;
      var raf = null;

      function check() {
        raf = null;
        if (revealed) return;
        var r = root.getBoundingClientRect();
        var vh = window.innerHeight || 1;
        if (r.top < vh && r.bottom > 0) {
          revealed = true;
          window.removeEventListener('scroll', onScroll);
          window.removeEventListener('resize', onScroll);
          revealItems(items);
        }
      }

      function onScroll() {
        if (raf === null) raf = window.requestAnimationFrame(check);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      check();
    }

    var sections = document.querySelectorAll('.nb-why');
    for (var i = 0; i < sections.length; i++) {
      if (sections[i].getAttribute('data-nb-why-ready') !== null) continue;
      sections[i].setAttribute('data-nb-why-ready', '');
      init(sections[i]);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var sections = document.querySelectorAll('.nb-product');
    for (var s = 0; s < sections.length; s++) {
      (function (root) {
        if (root.getAttribute('data-nb-product-ready') !== null) return;
        root.setAttribute('data-nb-product-ready', '');

        var main = root.querySelector('.nb-product__gallery-img');
        var thumbs = root.querySelectorAll('.nb-product__gallery-thumb');
        thumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function () {
            if (!main) return;
            main.src = thumb.getAttribute('data-img');
            thumbs.forEach(function (t) { t.classList.remove('is-active'); });
            thumb.classList.add('is-active');
          });
        });

        var qty = root.querySelector('.nb-product__qty');
        if (qty) {
          var input = qty.querySelector('input');
          var minus = qty.querySelector('[data-qty-minus]');
          var plus = qty.querySelector('[data-qty-plus]');
          minus.addEventListener('click', function () {
            var v = parseInt(input.value, 10) || 1;
            if (v > 1) { input.value = v - 1; }
          });
          plus.addEventListener('click', function () {
            var v = parseInt(input.value, 10) || 1;
            input.value = v + 1;
          });
        }

        var form = root.querySelector('#NbProductForm');
        if (form) {
          form.addEventListener('submit', function (e) {
            if (e.submitter && e.submitter.name === 'buy-now') {
              e.preventDefault();
              var variantInput = form.querySelector('input[name="id"], select[name="id"]');
              var qtyInput = form.querySelector('input[name="quantity"]');
              var id = variantInput ? variantInput.value : '';
              var qty = qtyInput ? qtyInput.value : 1;
              var planInput = form.querySelector('.selected-selling-plan-id');
              var plan = planInput ? planInput.value : '';
              var url = '/cart/add?id=' + id + '&quantity=' + qty;
              if (plan) { url += '&selling_plan=' + encodeURIComponent(plan); }
              window.location.href = url + '&return_to=/checkout';
            }
          });
        }

        var galleryItems = Array.prototype.slice.call(root.querySelectorAll('[data-nb-gallery-item]'));
        var lightbox = root.querySelector('[data-nb-lightbox]');
        if (lightbox && galleryItems.length) {
          var lbImg = lightbox.querySelector('[data-nb-lb-img]');
          var lbClose = lightbox.querySelector('[data-nb-lb-close]');
          var lbPrev = lightbox.querySelector('[data-nb-lb-prev]');
          var lbNext = lightbox.querySelector('[data-nb-lb-next]');
          var srcs = galleryItems.map(function (item) { return item.getAttribute('data-src'); });
          var current = 0;

          function show(index) {
            current = (index + srcs.length) % srcs.length;
            lbImg.src = srcs[current];
          }

          function open(index) {
            show(index);
            lightbox.hidden = false;
            document.body.style.overflow = 'hidden';
          }

          function close() {
            lightbox.hidden = true;
            lbImg.src = '';
            document.body.style.overflow = '';
          }

          galleryItems.forEach(function (item, i) {
            item.addEventListener('click', function () { open(i); });
          });

          lbClose.addEventListener('click', close);
          lbPrev.addEventListener('click', function () { show(current - 1); });
          lbNext.addEventListener('click', function () { show(current + 1); });
          lightbox.addEventListener('click', function (e) {
            if (e.target === lightbox) close();
          });
          document.addEventListener('keydown', function (e) {
            if (lightbox.hidden) return;
            if (e.key === 'Escape') close();
            else if (e.key === 'ArrowLeft') show(current - 1);
            else if (e.key === 'ArrowRight') show(current + 1);
          });
        }

        var subsBlock = root.querySelector('.subscriptions_app_embed_block');
        if (subsBlock) {
          var refreshSubs = function () {
            var labels = subsBlock.querySelectorAll('.shopify_subscriptions_app_block_label');
            for (var i = 0; i < labels.length; i++) {
              var label = labels[i];
              var kids = label.querySelector('.shopify_subscriptions_app_block_label_children');
              if (!kids || kids.parentElement !== label) continue;
              var radios = label.querySelectorAll('input[type="radio"]');
              var own = null;
              for (var r = 0; r < radios.length; r++) {
                if (!radios[r].closest('.shopify_subscriptions_app_block_label_children')) { own = radios[r]; }
              }
              var open = own ? own.checked : !!kids.querySelector('input[type="radio"]:checked');
              label.classList.toggle('is-open', open);
            }
          };
          refreshSubs();
          subsBlock.addEventListener('change', function (e) {
            if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) {
              setTimeout(refreshSubs, 0);
            }
          });

          subsBlock.addEventListener('click', function (e) {
            if (e.target && e.target.tagName === 'INPUT' && e.target.type === 'radio') return;
            var row = e.target && e.target.closest ? e.target.closest('.shopify_subscriptions_app_block_label') : null;
            if (!row || !subsBlock.contains(row)) return;
            var radios = row.querySelectorAll('input[type="radio"]');
            var own = null;
            for (var r = 0; r < radios.length; r++) {
              if (!radios[r].closest('.shopify_subscriptions_app_block_label_children')) { own = radios[r]; }
            }
            if (!own || own.checked) return;
            own.checked = true;
            own.dispatchEvent(new Event('change', { bubbles: true }));
          });

          var subsObserver = new MutationObserver(refreshSubs);
          subsObserver.observe(subsBlock, { childList: true, subtree: true });

          var planParam = new URLSearchParams(window.location.search).get('selling_plan');
          if (planParam) {
            var planAttempts = 0;
            var applyPlan = function () {
              var planRadio = subsBlock.querySelector('input[data-selling-plan-id="' + planParam + '"]');
              if (!planRadio) {
                if (planAttempts++ < 20) setTimeout(applyPlan, 250);
                return;
              }
              if (planRadio.checked) { refreshSubs(); return; }
              var groupRadio = subsBlock.querySelector('input[data-radio-type="selling_plan_group"]');
              if (groupRadio && !groupRadio.checked) { groupRadio.click(); }
              planRadio.click();
              setTimeout(refreshSubs, 0);
            };
            applyPlan();
          }
        }
      })(sections[s]);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
